import { render, staticRenderFns } from "./ContactDetailsView.vue?vue&type=template&id=40952f2a&scoped=true"
import script from "./ContactDetailsView.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./ContactDetailsView.vue?vue&type=style&index=0&id=40952f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40952f2a",
  null
  
)

export default component.exports